import { request } from '@/api/request';

const fetchApiHealth = () => request('GET', '/health');

export default {
  fetchApiHealth,
};
